import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AddToCartWithAttributesPayload, ItemMinimalDetails } from 'src/app/shared-core/models/cart-data.model';
import { SwiperContainer } from 'swiper/element';

@Component({
    selector: 'app-trending-products',
    templateUrl: './trending-products.component.html',
    styleUrls: ['./trending-products.component.scss']
})
export class TrendingProductsComponent {
    @Input() public source: string;
    @Input() public recommendations: ItemMinimalDetails[] = [];
    @Output() public addedToCart = new EventEmitter<AddToCartWithAttributesPayload>();
    @ViewChild('swiper') public swiper!: ElementRef<SwiperContainer>;
}